import { render } from "./DashboardAthleteView.vue?vue&type=template&id=8eeb4a5c"
import script from "./DashboardAthleteView.vue?vue&type=script&lang=js"
export * from "./DashboardAthleteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__